import React, { forwardRef, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./FramerWrapperArticle.module.scss";
import IconClose from "../../common/icons/IconClose";

const ArticleSkeleton = forwardRef(({ closePopup }, ref) => {
  useEffect(() => {
    const container = ref?.current;
    if (container) {
      const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = container;
        const isAtTop = scrollTop === 0;
        const isAtBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

        if ((isAtTop && e.deltaY < 0) || (isAtBottom && e.deltaY > 0)) {
          e.preventDefault();
        }
        e.stopPropagation();
      };

      container.addEventListener("wheel", handleScroll, { passive: false });

      return () => {
        container.removeEventListener("wheel", handleScroll);
      };
    } else {
    }
  }, [ref]);

  return (
    <>
      <div className={styles.modalBackdrop} onClick={closePopup} />
      <div className={styles.modalWrapper} data-article-modal>
        <div className={styles.articleContainer} ref={ref}>
          {/* Skeleton content... */}
          {/* Header */}
          <div className={styles.articleHeader}>
            <div className={styles.headerBackground}>
              <Skeleton height={300} />
            </div>
            <div className={styles.articleMetadata}>
              <div className={styles.headerTop}>
                <div className={styles.articleTags}>
                  <div className={styles.articleTagRow}>
                    <Skeleton width={80} height={24} />
                  </div>
                  <div className={styles.categoryTagRow}>
                    <Skeleton width={100} height={24} />
                    <Skeleton width={80} height={20} />
                    <Skeleton width={40} height={20} />
                  </div>
                </div>
                <div className={styles.chainLogo}>
                  <Skeleton circle height={40} width={40} />
                </div>
              </div>
              <div className={styles.headerBottom}>
                <Skeleton height={40} count={2} />
                <div className={styles.articleMeta}>
                  <Skeleton width={200} height={16} />
                </div>
              </div>
            </div>
          </div>

          {/* Author Section */}
          <div className={styles.authorSection}>
            <div className={styles.authorMobileWrapper}>
              <div className={styles.authorDetailsColumn}>
                <div className={styles.authorCard}>
                  <div className={styles.authorAvatar}>
                    <Skeleton circle height={50} width={50} />
                  </div>
                  <div className={styles.authorInfo}>
                    <Skeleton width={150} height={20} />
                    <Skeleton width={120} height={16} />
                  </div>
                </div>
              </div>
              <div className={styles.flagsColumn}>
                <div className={styles.languageFlags}>
                  <Skeleton circle height={30} width={30} />
                  <Skeleton circle height={30} width={30} />
                  <Skeleton circle height={30} width={30} />
                </div>
              </div>
            </div>
          </div>

          <div className={styles.dividerContainer}>
            <div className={styles.divider} />
          </div>

          {/* Content */}
          <div className={styles.articleContent}>
            <div className={styles.htmlContent}>
              <Skeleton height={20} count={15} />
            </div>
          </div>

          {/* Footer */}
          <div className={styles.articleFooter}>
            <div className={styles.tagsSection}>
              <Skeleton width={100} height={24} />
              <div className={styles.tagsContainer}>
                <Skeleton width={80} height={24} />
                <Skeleton width={90} height={24} />
                <Skeleton width={70} height={24} />
                <Skeleton width={100} height={24} />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.closeIcon} onClick={closePopup}>
          <IconClose />
        </div>
      </div>
    </>
  );
});

export default ArticleSkeleton;
